// extracted by css-extract-rspack-plugin
export default {"button":"_53a88887","disabled":"_99695a61","spinner":"_85f262ec"};